import { Component } from "react";
import { FormattedMessage } from "react-intl";
import { SessionStore } from "../uidispatcherapi/SessionStore";
import { Modal, ModalContent, ModalHeader, Spinner } from "@metro-ui/core";

type StateType = {
	showPopup: boolean;
};

class LogoutPopup extends Component<Record<PropertyKey, never>, StateType> {
	unsubscribe: (() => void) | null;

	constructor(props: Record<PropertyKey, never>) {
		super(props);
		this.state = {
			showPopup: false,
		};
		this.unsubscribe = null;
	}

	componentDidMount(): void {
		this.unsubscribe = SessionStore.listen(state => this.onSessionStoreChange(state));
	}

	componentWillUnmount(): void {
		this.unsubscribe?.();
		this.unsubscribe = null;
	}

	onSessionStoreChange(state: Record<string, any>): void {
		this.setState({
			showPopup: state.waitingForIdamLogout,
		});
	}

	render() {
		if (!this.state.showPopup) return null;

		return (
			<Modal isOpen zIndex={1050} padding="medium">
				<ModalHeader>
					<FormattedMessage id="PL_LOGGING_OUT_TITLE" />
				</ModalHeader>
				<ModalContent direction="column" align="center">
					<Spinner size="large" />
					<h4>
						<FormattedMessage id="PL_LOGGING_OUT_INFO" />
					</h4>
				</ModalContent>
			</Modal>
		);
	}
}

export default LogoutPopup;
